// extracted by mini-css-extract-plugin
export default {"filter_wrapper":"FilterWrapper_filter_wrapper__PqZuU"};